import React, { useContext, useState } from 'react';
import { Link } from 'react-router-dom';
import { Layout, Form, Input, Button, Typography } from 'antd';
import swal from 'sweetalert';
import { UserContext } from '../UserContext';
import './Login.css'
import axios from 'axios';

const {Content} = Layout
const {Title} = Typography;

const Login = () => {
  const {user, setUser} = useContext(UserContext)
  const [input, setInput] = useState({
    email : "",
    password: ""
  })

  const onChange = (e) => {
    const name = e.target.name
    const value = e.target.value
    
    setInput({
      ...input,
      [name] : value
    })
  }

  const onSubmit = () => {
    axios.post("https://backendexample.sanbersy.com/api/user-login", {
      email : input.email,
      password : input.password
    }).then((res) => {
      const result = res.data
      const data = {
        name : result.user.name,
        isLogged : true, 
        token: result.token
      }
      setUser(data)
      localStorage.setItem('user', JSON.stringify(data) )
    }).catch((err) => {
      swal(JSON.stringify(err.response.data), {icon: 'error'})
    })
  }

  return (
    <Content 
      className="site-layout"
    >
      <div id="login-form">
        <Form
        name="basic"
        labelCol={{ span: 5 }}
        wrapperCol={{ span: 12 }}
        initialValues={{ remember: true }}
        onFinish={onSubmit}
        >
          <Title level={2}>
            Login
          </Title>
          <Form.Item
            label="Email"
            name="email"
            rules={[{ required: true, message: 'Please input your email!' }]}
          >
            <Input name="email" onChange={onChange} />
          </Form.Item>

          <Form.Item
            label="Password"
            name="password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password name="password" onChange={onChange}/>
          </Form.Item>

          {/* <Form.Item name="remember" valuePropName="checked" wrapperCol={{ offset: 4, span: 6 }}>
            <Checkbox>Remember me</Checkbox>
          </Form.Item> */}

          <Form.Item wrapperCol={{ offset: 5, span: 6 }}>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Form.Item>
          
          <Link to="/register">
            <span className="create-or-log">Don't Have Account? Create now!</span>
          </Link>
        </Form>

      </div>
    </Content>
  )
}

export default Login